
import React from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'

import { useAuth } from '../../../Hooks/UseAuth'
import { useOptionsDialog } from '../../../Hooks/UseOptionsDialog'
import useTranslation from '@/Hooks/UseTranslation'
import { useFeedback } from '@/Hooks/UseFeedback'

import UserAvatar from '../../../Components/UserAvatar/UserAvatar'
import HeaderMainMenuItem from './HeaderMainMenuItem'

import './Header.scss'

interface Props {
  menu: any
}

const Header = ({ menu }: Props) => {

  const { t } = useTranslation()

  const history = useHistory()

  const { show: showFeedbackForm } = useFeedback()

  const { isOpen, show } = useOptionsDialog()

  const { userData , logout } = useAuth()

  const location = useLocation().pathname;

  const handleLogout = async () => {

    const { isConfirmed } = await Swal.fire({
      title: t('USER_MENU:Logout'),
      text: t('USER_MENU:LogoutConfirm'),
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: t('USER_MENU:LogoutConfirmButton'),
      cancelButtonText: t('USER_MENU:LogoutCancelButton')
    })

    if (!isConfirmed) return

    logout()
  }

  const handleShowUserDialog = () => {

    show(t('USER_MENU:User'), [
      {
        icon: <span className="icon-usuario"></span>,
        label: t('USER_MENU:MyProfile'),
        onClick: () => {
          history.push('/profile')
        }
      },
      {
        icon: <span className="icon-mensajes"></span>,
        label: t('USER_MENU:GiveFeedback'),
        onClick: () => showFeedbackForm()
      },
      {
        icon: <span className="icon-cancelar"></span>,
        label: t('USER_MENU:Logout'),
        onClick: () => handleLogout()
      }
    ])
  }

  return (
    <div className='main-header'>
      <div className="logo logo-left">
        <Link to="/">
          <img src="/svg-icons/logo.svg" style={{
            width: 130
          }} />
        </Link>
      </div>
      {menu && (
        <div className="d-none d-lg-block" style={{ flex: 1 }}>
          <ul className="project-menu">
            {menu.map((menuItem: any, i: number) => (
              <HeaderMainMenuItem key={i}
                icon={menuItem.icon}
                text={menuItem.text}
                path={menuItem.path}
                active={menuItem.active}
                disabled={menuItem.disabled}
              />
            ))}
          </ul>
        </div>
      )}
      <div className='logo logo-right'>
        <div
          className="btn-user-dialog cursor-pointer"
          onClick={() => handleShowUserDialog()}
        >
          {location == '/profile' && (
            <span className="username">
              {userData?.name} {userData?.surname}
            </span>
          )}
          {!userData?.avatar && (
            <span
              className={`${location == '/profile' || isOpen ? 'icon-usuario_full' : 'icon-usuario'}`}
            />
          )}
          {userData?.avatar && <UserAvatar user={userData} />}
          <div className="user-menu-name">
            {t('HEADER:Hi')}, {userData?.name}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
